import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { ServiceItem } from "../models/services/service-item";

@Injectable()
export class CategoryServicesService extends DataService<ServiceItem, ServiceItem> {

	constructor(
		protected http: HttpClient,
		protected notificationService: NotificationService) {
    super(http, notificationService);

    this.controllerName = 'services';
  }

}
